import { useEffect, useRef, useState } from "react";
import { Canceler } from "axios";
import { useFormContainerState, useTrans } from "../../../hooks";
import { useAuthData } from "../../../contexts";
import { VStack, useToast } from "@chakra-ui/react";
import {
    AppLoader,
    AppOptionBoxItem,
    AppOptionsBox,
    AppPageContent,
    AppPageHeader,
    AppWidgetCard,
} from "../../../components";
import { SchoolForm as FormComponent } from "./SchoolForm";
import { School as Entity, SchoolApi as EntityApi } from "../../../apis";
import { APPC } from "../../../config";

export const MySchoolPage = () => {
    // hook
    const { t } = useTrans();
    const { user } = useAuthData();
    const toast = useToast();
    const formContainerState = useFormContainerState();

    // state & const
    const [loadingList, setLoadingList] = useState(true);
    const [list, setList] = useState<Entity[]>([]);
    const [isDetailPage, setIsDetailPage] = useState(false);
    const cancelTokenSourcesRef = useRef<Canceler[]>([]);

    // handler
    const fetchListData = async () => {
        setLoadingList(true);
        const params = {
            pagination: false,
            "order[name]": "asc",
        };

        await EntityApi.getCollectionMySchools<Entity>(1, params, (c) => {
            cancelTokenSourcesRef.current.push(c);
        })
            .then(({ errorMessage, response }) => {
                if (errorMessage) {
                    toast({
                        title: errorMessage,
                        status: "error",
                    });
                } else if (response !== null) {
                    setList(response.items);
                }
            })
            .finally(() => setLoadingList(false));
    };

    const actionOptions: AppOptionBoxItem[] = [
        {
            key: "detail",
            label: t("cmn:option.detail"),
            iconName: "icl-eye",
        },
    ];

    if (
        user?.userType ===
            APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR_TRAINER ||
        user?.userType === APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_AND_COMPANY
    ) {
        actionOptions.push({
            key: "edit",
            label: t("cmn:option.edit"),
            iconName: "icl-pencil",
        });
    }

    const onActionClick = (key: string, data?: Entity) => {
        if (!data) {
            return;
        }
        switch (key) {
            case "edit":
                setIsDetailPage(false);
                formContainerState.open(data?.id);
                break;
            case "detail":
                setIsDetailPage(true);
                formContainerState.open(data?.id);
                break;
        }
    };

    // useEffect
    useEffect(() => {
        if (!formContainerState.isOpen) {
            fetchListData();
        }
    }, [formContainerState.isOpen]);

    if (loadingList) {
        return <AppLoader />;
    }

    return (
        <>
            <AppPageHeader
                title={t("padm.MySchoolPage:text.pageTitle")}
            ></AppPageHeader>
            <AppPageContent>
                <>
                    <VStack p={6} gap={6}>
                        {list.map((item) => (
                            <AppWidgetCard
                                key={item.id}
                                data={item}
                                actionElement={
                                    <AppOptionsBox
                                        options={actionOptions}
                                        data={item}
                                        onClick={onActionClick}
                                    />
                                }
                            />
                        ))}
                    </VStack>
                    {formContainerState.isOpen && (
                        <FormComponent
                            formContainerState={formContainerState}
                            isDetailPage={isDetailPage}
                        />
                    )}
                </>
            </AppPageContent>
        </>
    );
};
